import { Form, Input, Button } from "antd";
import { withTranslation } from "react-i18next"
import { useState } from "react";
import styled from "styled-components";
import { MdAlternateEmail } from "react-icons/md";
import { IoPrint } from "react-icons/io5";

const StyledForm = styled(Form)`
  .ant-form-item-label>label.ant-form-item-required:not(.ant-form-item-required-mark-optional):before {
    content: ''
  }
`;

/**
 * ForOther
 * @param {*} props 
 * @returns 
 */
const ForOther = (props) => {
  const [sendByMail, setSendByMail] = useState(true)

  const onFinish = (values) => {
    props.setUserSelection({
      ...props.userSelection, 
      userFromName: values.userFromName,
      userToName: values.userToName,
      message: values.message,
      email: values.email,
      to_email: values.to_email,
      type: sendByMail ? 'by_email' : 'print'
    })

    props.setCurrentView('basket')    
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      <StyledForm
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item
          label={props.t('Giftcard.Recipients.ForOther.Form.UserFromName', 'Votre nom')}
          name="userFromName"
          rules={[
            {
              required: true,
              message: props.t('Giftcard.Recipients.ForOther.Form.Error', 'Ce champ est obligatoire'),

            },
          ]}
          initialValue={props.userSelection.userFromName}
        >
          <Input style={{ borderRadius: 5, width: '100%'}} />
        </Form.Item>

        <Form.Item
          label={props.t('Giftcard.Recipients.ForOther.Form.Email', 'Votre adresse E-Mail')}
          name="email"
          rules={[
            {
              type: 'email',
              required: true,
              message: props.t('Giftcard.Recipients.Email.Form.Error', 'Ce champ est obligatoire'),
            },
          ]}
          initialValue={props.userSelection.email}
        >
          <Input style={{ borderRadius: 5, width: '100%'}} />
        </Form.Item>

        <Form.Item
          label={props.t('Giftcard.Recipients.ForOther.Form.UserToName', 'Nom du destinataire')}
          name="userToName"
          rules={[
            {
              required: true,
              message: props.t('Giftcard.Recipients.ForOther.Form.Error', 'Ce champ est obligatoire'),

            },
          ]}
          initialValue={props.userSelection.userToName}

        >
          <Input style={{ borderRadius: 5, width: '100%'}} />
        </Form.Item>

        <Form.Item
          label={(<div style={{ display: 'flex'}}><div>{props.t('Giftcard.Recipients.ForOther.Form.Message', 'Message')}</div> <div style={{ marginLeft: 'auto'}}>(facultatif)</div></div>)}
          name="message"
          initialValue={props.userSelection.message}

        >
          <Input.TextArea style={{ borderRadius: 5, width: '100%', height: 100 }} />
        </Form.Item>

        <div style={{ display: 'flex', border: '1px solid #e5e7eb', borderRadius: 5, width: '90%', margin: 'auto', height: 50, marginBottom: 20 }}>
          <div 
            onClick={() => setSendByMail(true)}
            style={{ width: '50%', background: sendByMail ? '#CCEAED' : 'white', borderRight: '1px solid #e5e7eb', borderRadius: '5px 0 0 5px', color: '#333', fontSize: 18, padding: 10, display: 'flex', cursor: 'pointer' }}>
            <MdAlternateEmail style={{ marginTop: 5, marginLeft: 20 }} />
            <div style={{ textAlign: 'center', width: 150, lineHeight: 1.1, marginTop: 5 }}>           
              E-Mail
            </div>
          </div>

          <div 
            onClick={() => setSendByMail(false)}
            style={{ width: '50%', background: sendByMail ? '#FFFFFF' : '#CCEAED', borderRadius: 5, color: '#333', fontSize: 18, padding: 10, display: 'flex', cursor: 'pointer' }}>
            <IoPrint style={{ marginTop: 5, marginLeft: 20 }} />
            <div style={{ textAlign: 'center', width: 150, lineHeight: 1.1, marginTop: 5 }}>
              Imprimer
            </div>
          </div>
        </div>
        
        {
          sendByMail && (
            <Form.Item
              label={props.t('Giftcard.Recipients.ForOther.Form.ToEmail', 'À quelle adresse email devons-nous l envoyer?')}
              name="to_email"
              rules={[
                {
                  type: "email",
                  required: true,
                  message: props.t('Giftcard.Recipients.ForOther.Form.Error', 'Ce champ est obligatoire'),
    
                },
              ]}
              initialValue={props.userSelection.to_email}
            >
              <Input type="email" style={{ borderRadius: 5, width: '100%'}} />
            </Form.Item>
          )
        }

        <Form.Item
        >
          <Button type="primary" htmlType="submit" style={{ width: '100%'}}>
            Continuer
          </Button>
        </Form.Item>
      </StyledForm>
    </>
  )
}

export default withTranslation()(ForOther);